const projectMemberActions = [
  {
    value: 'edit',
    label: 'Edit Profile',
    icon: 'edit',
    iconLibrary: 'material',
    isPrimary: false,
    displayInMenu: false,
  },
  {
    value: 'invite',
    label: 'Invite to New Role',
    icon: 'assignment_ind',
    iconLibrary: 'material',
    isPrimary: false,
    displayInMenu: true,
  },
  {
    value: 'join-supporter',
    label: 'Change Role to Supporter',
    icon: 'diversity_3',
    iconLibrary: 'material',
    isPrimary: false,
    displayInMenu: true,
  },
  {
    value: 'request-supporter',
    label: 'Request Supporter Role',
    icon: 'diversity_3',
    iconLibrary: 'material',
    isPrimary: false,
    displayInMenu: true,
  },
  {
    value: 'join-contributor',
    label: 'Change Role to Contributor',
    icon: 'communities',
    iconLibrary: 'material',
    isPrimary: false,
    displayInMenu: true,
  },
  {
    value: 'request-contributor',
    label: 'Request Contributor Role',
    icon: 'communities',
    iconLibrary: 'material',
    isPrimary: false,
    displayInMenu: true,
  },
  {
    value: 'deactivate',
    label: 'Leave Project',
    labelByContext: (context) => context?.isSelf ? 'Leave Project' : 'Deactivate Member',
    icon: 'logout',
    iconLibrary: 'material',
    isPrimary: false,
    displayInMenu: true,
  },
];
const projectMemberActionsMap = Object.fromEntries(
  projectMemberActions.map((o, index) => [o.value, { ...o, index }])
);
const projectMemberActionsMap_byContext = (context) => Object.fromEntries(
  projectMemberActions.map((a, index) => {
    const action = { ...a, index };
    
    if (action.labelByContext) action.label = action.labelByContext(context);

    return [action.value, action];
  })
);

export {
  projectMemberActions,
  projectMemberActionsMap,
  projectMemberActionsMap_byContext,
};
